
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import * as LucideIcons from "lucide-react";

interface IconPickerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedIcon: string;
  setSelectedIcon: (icon: string) => void;
  onPick: (icon: string) => void;
  commonIcons: string[];
  setFormIconName: (icon: string) => void;
}

const IconPickerDialog = ({
  open,
  onOpenChange,
  selectedIcon,
  setSelectedIcon,
  onPick,
  commonIcons,
  setFormIconName
}: IconPickerDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Select Icon</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-8 gap-2 max-h-64 overflow-y-auto">
          {commonIcons.map((iconName) => {
            const Icon = (LucideIcons as any)[iconName];
            return (
              <Button
                key={iconName}
                variant={selectedIcon === iconName ? "default" : "outline"}
                size="sm"
                className="h-12 w-12 p-0"
                onClick={() => {
                  setSelectedIcon(iconName);
                  setFormIconName(iconName);
                  if (onPick) onPick(iconName);
                  onOpenChange(false);
                }}
              >
                <Icon className="h-5 w-5" />
              </Button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default IconPickerDialog;
